import type { SourcesContent } from "@/types/report";

interface Props {
  content: SourcesContent;
}

export function SourcesSection({ content }: Props) {
  return (
    <div className="report-sources">
      <h3>Sources</h3>
      {content.items.map((item, i) => (
        <div key={i} className="report-source-item">
          {item.url ? (
            <a href={item.url} target="_blank" rel="noreferrer noopener">
              {item.title}
            </a>
          ) : (
            <span>{item.title}</span>
          )}
          {item.description && (
            <span style={{ marginLeft: 8, color: "var(--report-text-muted, #888)" }}>
              — {item.description}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
